import { useReactTable } from '@tanstack/react-table'
import { useMemo } from 'react'

export function useTable({ columns: cols, ...props }) {
    const columns = useMemo(() => {
        return cols.map((col) => {
            const {
                default: def,
                className,
                style,
                headerClassName,
                headerStyle,
                cellClassName,
                cellStyle,
                filterElement,
                filterClassName,
                filterStyle,
                meta,
                ...rest
            } = col
            return {
                ...rest,
                meta: {
                    ...meta,
                    default: def,
                    className,
                    style,
                    headerClassName,
                    headerStyle,
                    cellClassName,
                    cellStyle,
                    filterElement,
                    filterClassName,
                    filterStyle,
                },
            }
        })
    }, [cols])

    return useReactTable({
        columns,
        enableSorting: false,
        enableColumnFilters: false,
        enableRowSelection: false,
        ...props,
    })
}
